import React from 'react';
import { DollarSign, Sparkles, FileText } from 'lucide-react';
import { pricingContent } from '@/hooks/useContent';

// Icon mapping
const iconMap = {
  Sparkles: Sparkles,
  FileText: FileText,
  DollarSign: DollarSign,
};

const Pricing = () => {
  const content = pricingContent;

  return (
    <section 
      className="py-24" 
      style={{ backgroundColor: content.background?.color || '#1e1919' }}
      data-testid="pricing-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: '#E8DCC8' }} data-testid="pricing-title">
            {content.title}
          </h2>
          <p className="text-xl max-w-3xl mx-auto" style={{ color: '#D4C4A8' }} data-testid="pricing-subtitle">
            {content.subtitle}
          </p>
        </div>

        {/* Pricing Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {content.features?.map((feature, index) => {
            const IconComponent = iconMap[feature.icon] || Sparkles;
            return (
              <div 
                key={index}
                className="p-8 rounded-lg transition-all duration-300 hover:scale-105"
                style={{ backgroundColor: '#2a2a2a' }}
                data-testid={`pricing-feature-${index}`}
              >
                <div 
                  className="mb-4 inline-block p-3 rounded-lg"
                  style={{ 
                    backgroundColor: '#8B7355',
                    color: 'white'
                  }}
                >
                  <IconComponent size={32} />
                </div>
                <h3 className="text-xl font-bold mb-3" style={{ color: '#E8DCC8' }}>
                  {feature.title}
                </h3>
                <p className="text-base leading-relaxed" style={{ color: '#D4C4A8' }}>
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA Box */}
        <div 
          className="max-w-3xl mx-auto p-8 md:p-12 rounded-lg text-center"
          style={{ 
            backgroundColor: '#8B7355',
            backgroundImage: 'linear-gradient(135deg, #8B7355 0%, #C9A873 100%)'
          }}
          data-testid="pricing-cta-box"
        >
          <h3 className="text-2xl md:text-3xl font-bold mb-4 text-white">
            {content.cta_title}
          </h3>
          <p className="text-lg mb-6 text-white/90">
            {content.cta_description}
          </p>
          <button 
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-4 rounded-md font-semibold text-lg transition-all duration-300 bg-white hover:bg-gray-100"
            style={{ color: '#8B7355' }}
            data-testid="pricing-cta-button"
          >
            {content.cta_button_text}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
